import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { processActions } from "../../reducer/processReducer";
import logoSplash from "../../images/logo_splash.png";

class ForgottenPassEmail extends Component {
  state = {
    email: "",
  };

  // eslint-disable-next-line consistent-return
  componentDidMount() {
    document.title = "Забравена парола - Email - A1 Xplore TV GO";

    const { history, process, forgottenPassResetResults } = this.props;

    if (
      !(
        process.forgottenPassEmail &&
        process.forgottenPassCheckEmailResult &&
        process.forgottenPassCheckEmailResult.isOk === true
      )
    ) {
      history.push("/passrecovery");
      return false;
    }

    this.setState({ email: process.forgottenPassEmail });

    forgottenPassResetResults();
  }

  render() {
    const { email } = this.state;

    return (
      <div className="page page-confirm">
        <div className="header-bg" />

        <div className="container container--small">
          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>
          <div className="container-body">
            <h1 className="tag-title">Забравена парола</h1>

            <div className="tag-content">
              <p>Изпратихме ти e-mail с инструкции на</p>
              <h3 className="tag-color-red no-break-out">{email}</h3>
            </div>

            <div className="tag-content tag-content__help" style={{ marginTop: "40px" }}>
              Не получи ли e-mail?{" "}
              <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
                Помощ
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    forgottenPassResetResults: () => dispatch(processActions.forgottenPassResetResults()),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ForgottenPassEmail);
